import { useQuery } from "@tanstack/react-query";
import { DiscountsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { useAccessToken } from "@/hooks";

interface UseDiscountsGetProps {
  enabled?: boolean;
}

export const useDiscountsGet = ({ enabled = true }: UseDiscountsGetProps = {}) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.Discounts],
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(DiscountsApi, accessToken);
      return service.apiDiscountsGet({});
    },
    enabled: enabled !== false && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};